'use client'

import { ActionIcon, Menu, Text } from '@mantine/core'
import { RiCheckboxCircleFill, RiGlobalLine } from '@remixicon/react'
import { setUserLocale } from '@repo/ui'
import { useLocale } from 'next-intl'
import { useTransition } from 'react'

export function LanguageSelectorGlobal() {
  const currentLocale = useLocale()
  const [, startTransition] = useTransition()

  const handleChange = (locale: string) => {
    if (currentLocale === locale) return
    startTransition(() => {
      setUserLocale(locale)
    })
  }

  return (
    <Menu shadow='md' width={160} position='bottom-end' withArrow>
      <Menu.Target>
        <ActionIcon variant='transparent' size='sm'>
          <RiGlobalLine size={16} />
        </ActionIcon>
      </Menu.Target>

      <Menu.Dropdown>
        <Menu.Item
          onClick={() => handleChange('en')}
          rightSection={
            currentLocale === 'en' && <RiCheckboxCircleFill size={20} />
          }
        >
          <Text size='sm'>English</Text>
        </Menu.Item>
        <Menu.Item
          onClick={() => handleChange('ar-EG')}
          rightSection={
            currentLocale === 'ar-EG' && <RiCheckboxCircleFill size={20} />
          }
        >
          <Text size='sm'>العربية</Text>
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  )
}
